'use client';
import React from "react";

export default function Rankings() { 
    return (
        <div className="rankings">
            <a href="/ranking" target="_ranking" rel="noreferrer"></a>
        </div>
    )
}